import { Paymentprovider } from "../entities";

export class PaymentproviderLogic {
    static initEmptyPaymentprovider(): Paymentprovider {
        return {
            id: '',
            type: 0,
            name: '',
            mastercard: 0,
            visa: 0,
            api_user: '',
            api_password: '',
            description: '',
            hint: '',
            min_duration: 0,
            min_amount: 0.0,
            livemode: 0,
            customer_id: '',
            project_id: '',
            secret_key: '',
            deadlinedays: 0,
            brandname: '',
            response_header: '',
            response_text: ''
        };
    }
}